module.exports = __webpack_public_path__ + "img/jyiwen.3d2c26dd.gif";